import React from 'react';
import { Container } from './styles';

const Background = props => (
  <Container {...props} />
);

export default Background;
